module.exports = __webpack_public_path__ + "img/haverim_no.e19d1de7.png";